export const brandScoreMessages = {
    opportunity: {
        headerMessage: 'Take action on the biggest opportunities for your brand',
        noOpportunities:
            'Your selections do not have any opportunities to display. Please try a new set of selections or check back next week!',
        clickRunNowSuggestion: 'Click Run Now to see the new opportunities!',
    },
};
